( function () {
	'use strict';

	class TabsAutomatic {
		constructor( groupNode ) {
			this.tablistNode = groupNode;
			this.tabs = [];
			this.tabpanels = [];
			this.firstTab = null;
			this.lastTab = null;

			Array.from(
				this.tablistNode.querySelectorAll( '[role="tab"]' )
			).forEach( ( tab ) => {
				const tabpanel = document.getElementById(
					tab.getAttribute( 'aria-controls' )
				);

				if ( ! tabpanel ) {
					return;
				}

				tab.tabIndex = -1;
				tab.setAttribute( 'aria-selected', 'false' );

				this.tabs.push( tab );
				this.tabpanels.push( tabpanel );

				tab.addEventListener( 'keydown', this.onKeydown.bind( this ) );
				tab.addEventListener( 'click', this.onClick.bind( this ) );
			} );

			this.firstTab = this.tabs[ 0 ] || null;
			this.lastTab = this.tabs[ this.tabs.length - 1 ] || null;

			if ( this.firstTab ) {
				this.setSelectedTab( this.firstTab, false );
			}
		}

		setSelectedTab( currentTab, setFocus = true ) {
			this.tabs.forEach( ( tab, index ) => {
				const tabpanel = this.tabpanels[ index ];

				if ( currentTab === tab ) {
					tab.setAttribute( 'aria-selected', 'true' );
					tab.tabIndex = 0;
					tabpanel.classList.remove( 'is-hidden' );
					tabpanel.removeAttribute( 'hidden' );

					if ( setFocus ) {
						tab.focus();
					}

					return;
				}

				tab.setAttribute( 'aria-selected', 'false' );
				tab.tabIndex = -1;
				tabpanel.classList.add( 'is-hidden' );
				tabpanel.setAttribute( 'hidden', '' );
			} );
		}

		setSelectedToPreviousTab( currentTab ) {
			if ( currentTab === this.firstTab ) {
				this.setSelectedTab( this.lastTab );
				return;
			}

			const currentIndex = this.tabs.indexOf( currentTab );
			this.setSelectedTab( this.tabs[ currentIndex - 1 ] );
		}

		setSelectedToNextTab( currentTab ) {
			if ( currentTab === this.lastTab ) {
				this.setSelectedTab( this.firstTab );
				return;
			}

			const currentIndex = this.tabs.indexOf( currentTab );
			this.setSelectedTab( this.tabs[ currentIndex + 1 ] );
		}

		onKeydown( event ) {
			const target = event.currentTarget;
			let handled = false;

			switch ( event.key ) {
				case 'ArrowLeft':
				case 'ArrowUp':
					this.setSelectedToPreviousTab( target );
					handled = true;
					break;

				case 'ArrowRight':
				case 'ArrowDown':
					this.setSelectedToNextTab( target );
					handled = true;
					break;

				case 'Home':
					this.setSelectedTab( this.firstTab );
					handled = true;
					break;

				case 'End':
					this.setSelectedTab( this.lastTab );
					handled = true;
					break;

				default:
					break;
			}

			if ( handled ) {
				event.preventDefault();
				event.stopPropagation();
			}
		}

		onClick( event ) {
			this.setSelectedTab( event.currentTarget );
		}
	}

	function initTabs() {
		const tablists = document.querySelectorAll(
			'[role="tablist"].automatic'
		);

		tablists.forEach( ( tablist ) => {
			if ( 'true' === tablist.dataset.vivaTabsInitialized ) {
				return;
			}

			tablist.dataset.vivaTabsInitialized = 'true';
			new TabsAutomatic( tablist );
		} );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', initTabs );
	} else {
		initTabs();
	}
} )();
